import { useMemo } from 'react'
import { GameOption } from '../types'
import { Typeahead } from '@Components/common/typeahead'
import '../styles.scss'

type GameMultiselectProps = {
  gameOptions: GameOption[]
  selectedGameIds: string[]
  disabled?: boolean
  onChange: (selectedIds: string[]) => void
}

type GameSelectOption = {
  value: string
  label: string
  subtitle: string
}

export const GameMultiselect = ({
  gameOptions,
  selectedGameIds,
  disabled = false,
  onChange,
}: GameMultiselectProps) => {
  const options = useMemo(
    () =>
      gameOptions.map((game) => ({
        value: game.value,
        label: game.label,
        subtitle: game.subtitle,
      })),
    [gameOptions],
  )

  const selectedOptions = useMemo(
    () => options.filter((option) => selectedGameIds.includes(option.value)),
    [options, selectedGameIds],
  )

  const handleChange = (selected: readonly GameSelectOption[] | null) => {
    onChange(selected ? selected.map((option) => option.value) : [])
  }

  return (
    <div className="game-multiselect-react">
      <Typeahead<GameSelectOption, true>
        classNamePrefix="game-select"
        isMulti
        isClearable
        isDisabled={disabled}
        placeholder="Search by Game Name, ID, etc..."
        value={selectedOptions}
        options={options}
        onChange={handleChange}
        formatOptionLabel={(option) => (
          <div className="game-select-option-content">
            <div className="game-select-option-label">{option.label}</div>
            <div className="game-select-option-subtitle">{option.subtitle}</div>
          </div>
        )}
      />
    </div>
  )
}
